(() => {
  const ITEM_SELECTOR = '.cst-faq-item';
  const ANSWER_SELECTOR = '.faq-answer';
  const TRANSITION_MS = 400;
  const timers = new WeakMap();

  function clearTimer(item) {
    const timer = timers.get(item);
    if (timer) {
      clearTimeout(timer);
      timers.delete(item);
    }
  }

  function openItem(item) {
    const answer = item.querySelector(ANSWER_SELECTOR);
    if (!answer) return;

    clearTimer(item);
    const startHeight = item.hasAttribute('open') ? answer.getBoundingClientRect().height : 0;
    item.setAttribute('open', '');
    item.classList.add('active');
    answer.style.height = `${startHeight}px`;

    requestAnimationFrame(() => {
      answer.style.height = `${answer.scrollHeight}px`;
      timers.set(
        item,
        setTimeout(() => {
          answer.style.height = '';
          timers.delete(item);
        }, TRANSITION_MS)
      );
    });
  }

  function closeItem(item) {
    const answer = item.querySelector(ANSWER_SELECTOR);
    if (!answer) return;

    clearTimer(item);
    item.classList.remove('active');
    answer.style.height = `${answer.getBoundingClientRect().height}px`;

    requestAnimationFrame(() => {
      answer.style.height = '0px';
      timers.set(
        item,
        setTimeout(() => {
          item.removeAttribute('open');
          answer.style.height = '';
          timers.delete(item);
        }, TRANSITION_MS)
      );
    });
  }

  function initCustomFaq(container) {
    const allFAQs = container.querySelectorAll(ITEM_SELECTOR);

    allFAQs.forEach((faq) => {
      const summary = faq.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        const isOpen = faq.classList.contains('active');

        allFAQs.forEach((item) => {
          if (item !== faq && item.hasAttribute('open')) closeItem(item);
        });

        if (isOpen) {
          closeItem(faq);
        } else {
          openItem(faq);
        }
      });
    });
  }

  function observe(container) {
    if (!('IntersectionObserver' in window)) {
      initCustomFaq(container);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            initCustomFaq(container);
            observer.disconnect();
          }
        });
      },
      { rootMargin: '200px' }
    );
    observer.observe(container);
  }

  function start() {
    document.querySelectorAll('.custom-faqs').forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
